import React, { useEffect } from "react";
import { IStudentResources } from "../../../../../models/dashboard/studentDashboard";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { getPageBlockData } from "../../../../../common-functions/commonFunctions";
import { limit, pageBlockId } from "../../../../../constants/pageBlocks";
import { setWidgets } from "../../../../../store/slices/master/widgetSlice";
import { ROUTER_URL } from "../../../../../constants/routerUrl";
import { IWidgets } from "../../../../../models/master/widgets";
import { baseURL } from "../../../../../constants/commonConstants";
import { getWidgets } from "../../../../../action/masters/widgetActionCreator";

const BetaStudentResourceWidgets = (props: IStudentResources) => {
  const { getAllStudentResources, widgets, snapShots } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pageBlockData = getPageBlockData(
    snapShots,
    pageBlockId.studentResources
  );

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getAllStudentResources(pageBlockId.studentResources, limit.four);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setWidgets([]));
    };
  }, []);

  const handleViewALL = () => {
    navigate(ROUTER_URL.RESOURCES);
  };
  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Student Resources</h2>
          <a
            onClick={handleViewALL}
            title="View All Student Resources"
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
          >
            View All
          </a>
        </div>
        <div className="row">
          {widgets
            ?.filter((widget: IWidgets) => widget.displayOrNot)
            .map((widget: IWidgets) => (
              <div className="col-lg-12" key={widget.id}>
                <a href={widget.url} target="_blank" rel="noopener noreferrer">
                  <div className="widget-card d-flex align-items-center gap-2">
                    <div className="icon">
                      <img src={baseURL + widget.image} alt={widget.name} />
                    </div>
                    <div className="desc">
                      <h3>{widget.name}</h3>
                      <p className="para-hide-1">{widget.description}</p>
                      <a href={widget.url} className="btn-arrow">
                        <img
                          src="/assets/images/icon/arrow-right.svg"
                          alt="Arrow icon"
                        />
                      </a>
                    </div>
                  </div>
                </a>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllStudentResources: (pageBlockId: number, noOfItems: number) =>
    getWidgets(undefined, pageBlockId, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    widgets: state.widget.widgets,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(BetaStudentResourceWidgets));
